import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../theme/theme';

interface SegmentedTabsProps<T extends string> {
  value: T;
  options: { key: T; label: string }[];
  onChange: (value: T) => void;
}

function SegmentedTabs<T extends string>({ value, options, onChange }: SegmentedTabsProps<T>) {
  return (
    <Box sx={{ display: 'inline-flex', backgroundColor: '#f1f1f4', borderRadius: '12px', padding: '4px', gap: '2px' }}>
      {options.map((opt) => {
        const active = opt.key === value;
        return (
          <Box
            key={opt.key}
            onClick={() => onChange(opt.key)}
            sx={{
              padding: '8px 18px',
              borderRadius: '9px',
              cursor: 'pointer',
              backgroundColor: active ? '#ffffff' : 'transparent',
              boxShadow: active ? '0 2px 6px rgba(0,0,0,0.08)' : 'none',
              transition: 'background-color 150ms ease, color 150ms ease',
              '&:hover': active ? undefined : { color: colors.textPrimary },
            }}
          >
            <Typography sx={{ fontSize: 13.5, fontWeight: active ? 700 : 600, color: active ? colors.primary : colors.greyText }}>
              {opt.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default SegmentedTabs;
